/* eslint-disable @typescript-eslint/no-explicit-any */
import { partnerTemplatesDataUrlSlugs } from "@/templates/software/confluence/templates/confluence-templates-page/src/test-data/test-data.ts";

import {
    lightTemplateFragment,
    assetFragment,
    collectionFragment,
    relatedTemplateFragment
} from "../fragments";
import {
    ITemplatePageLoader,
    parseCategories,
    parseCollection,
    parseTemplate
} from "../get-content-data";

export const ConfluenceTemplateSearchPageLoader: ITemplatePageLoader = {
    getQueryData: (_: any, locale: string, after?: string) => {
        return {
            query: `#graphql
            query getAllTemplates($search: ContentPlatformSearchAPIv2Query!) {
                templates(search: $search) {
                    edges {
                        node {
                            ...lightTemplateFragment
                        }
                    }
                    pageInfo {
                        hasNextPage
                        endCursor
                    }
                }
                partnerTemplates: templates(search: { queries: { withLocales: ["${locale}"], where: {
                    fieldNamed: "urlSlug",
                    havingValues:
                        ${JSON.stringify(partnerTemplatesDataUrlSlugs)}
                } }}) {
                    edges {
                        node {
                            oneLinerHeadline
                            ...lightTemplateFragment
                        }
                    }
                }
                templateCollections(search: { queries: { first: 50, withLocales: ["${locale}"] }}) {
                    edges {
                        node {
                            ...collectionFragment

                        }
                    }
                }
                contentFacet(first: 25, forFields: ["category"], forContentType: "Template", withLocales: ["${locale}"]) {
                    edges {
                      node {
                        context
                      }
                    }
                  }
            }
            ${lightTemplateFragment}
            ${collectionFragment}
            ${assetFragment}
            ${relatedTemplateFragment}
            `,
            variables: {
                search: {
                    queries: { first: 200, withLocales: [locale], after }
                }
            }
        };
    },
    parseData: (data: any, locale?: string) => {
        const templates = [];
        const collections = [];
        const partnerTemplates = [];
        const categories = parseCategories(data.contentFacet.edges, locale);
        for (const { node } of data.templates.edges) {
            templates.push(parseTemplate(node));
        }

        for (const { node } of data.partnerTemplates.edges) {
            partnerTemplates.push(parseTemplate(node));
        }

        for (const { node } of data.templateCollections.edges) {
            collections.push(parseCollection(node));
        }

        return {
            templates,
            partnerTemplates,
            collections,
            categories
        };
    },
    multiplePagesQuery: true
};
